import { StarIcon } from 'lucide-react'
import { HTMLAttributes } from 'react'
import { ReviewItem } from './review-item'
import { cn } from '@/utils/cn'
export type ReviewListUIProps = {
  reviews: ReviewItem[]
}

export const ReviewListUI = ({
  className,
  reviews,
  ...props
}: ReviewListUIProps & HTMLAttributes<HTMLDivElement>) => {
  const avgRating =
    reviews.reduce((acc, review) => acc + review.rating, 0) / reviews.length

  return (
    <div className={cn(className)} {...props}>
      <div className="flex items-baseline gap-1 text-heading-02-bold">
        <h2>쿠팡 한 줄 리뷰</h2>
        <span className="ml-1 text-gray-400">{reviews.length}</span>
      </div>
      <div className="mt-4 flex items-center gap-1 text-title-01">
        <StarIcon fill="#ff6401" className="size-6 text-primary" />
        <span className="text-primary">{avgRating.toFixed(1)}</span>
        <span className="text-gray-400">/ 5</span>
      </div>
      <div className="mt-4 flex gap-3 overflow-x-scroll scrollbar-hide">
        {reviews.map((review) => (
          <ReviewItem key={review.id} {...review} />
        ))}
      </div>
    </div>
  )
}
